export default __webpack_public_path__ + "static/media/ring4.3005d6ce.png";